import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { isOverdue } from '@platform/core/lib/format';
import { isDoneStatus } from '@platform/engine/views/doneStatuses';
import type { IControlProps } from '../IControlProps';
import { isDeadlineField } from '../options/isDeadlineField';

/**
 * Дата (UIUX/field-types/date, controls/date-input): нативне поле дати у вигляді текстового, 34px (sm/inline — 30px), значення ISO
 * yyyy-mm-dd, порожнє — null. Прострочений термін (due/deadline до сьогодні, статус запису `record` не з DONE прототипу) позначають ключовий рядок і міні-форма —
 * текст --danger у пігулці, як у прототипі (у групах форми й у редагуванні в рядку дата звичайна; таблиця фарбує сам текст клітинки).
 * У ключовому рядку (key) з міткою prefix — пігулка «ТЕРМІН: дата», без неї — поле без рамки всередині пігулки. Лише для перегляду —
 * те саме поле дати (прототип v4: порожнє показує «дд.мм.рррр» і значок календаря).
 */
export function DateInput({ value, onChange, readOnly, id, field, size = 'md', prefix, record, invalid, autoFocus, compact }: IControlProps<string>) {
  const { t } = useTranslation();
  const iso = (value ?? '').slice(0, 10);
  const late = (size === 'key' || Boolean(compact)) && Boolean(record) && isDeadlineField(field) && isOverdue(iso || null, isDoneStatus(record?.status));
  const classes = cx('control', 'fc-date', size !== 'md' && `fc--${size}`, late && 'is-overdue', readOnly && 'control--ro');
  const input = (
    <input id={id} type="date" className={classes} value={iso} readOnly={readOnly} aria-invalid={invalid || undefined} autoFocus={autoFocus}
      title={late ? t('fieldControls.overdue') : undefined} onChange={(e) => onChange(e.target.value || null)} />
  );
  if (size !== 'key' || !prefix) return input;
  return (
    <label className={cx('fc-keydate', late && 'is-overdue', readOnly && 'is-ro')} htmlFor={id}>
      <span className="pk__prefix">{prefix}</span>
      {input}
    </label>
  );
}
